import { render, staticRenderFns } from "./GadgetsPage.vue?vue&type=template&id=f2a603da&scoped=true&"
import script from "./GadgetsPage.vue?vue&type=script&lang=js&"
export * from "./GadgetsPage.vue?vue&type=script&lang=js&"
import style0 from "./GadgetsPage.vue?vue&type=style&index=0&id=f2a603da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a603da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
